var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"at-eg-task",class:[_vm.classFloor, _vm.workClass],style:('width:'+_vm.task.duration*100+'%;z-index: 999;'),attrs:{"title":_vm.task.title}},[_c('div',{staticClass:"at-eg-task-inner"},[_vm._v(_vm._s(_vm.task.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }